import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import Sortable      from 'react-sortablejs';
import ContentsModal from 'contents_modal';

import ProgressCard     from './progress-card';

// -------------------------------------------------------


class ProgressBase extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      group_data       : {},
      group_modal      : false,
      influencer_modal : false,
    };
  }
  // -------------------------------------------------------
  
  toggleGroupModal(flg, data) {
    this.setState({ group_modal: flg, group_data: data });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    let data = this.props.data;
    
    let list = data.list;
    if( list == undefined ) list = [];
    
    let statusList = {};
    this.props.base_targets.map((d) => {
      let unique_id = String(d.status.recommend_date);
      let order = (d.status.recommend_date == null) ? 0 : Moment(d.status.recommend_date).unix();
      if( statusList[unique_id] == undefined ) statusList[unique_id] = { order: order, recommend_date: d.status.recommend_date, recommend_text: d.status.recommend_text, ary: [] };
      statusList[unique_id].ary.push(d);
    });
    
    console.log(statusList);
    
    let statusArray = [];
    for( let i in statusList ) statusArray.push(statusList[i]);
    statusArray = Utils.sort(statusArray, 'order', 'asc');
    
    let notList = [];
    this.props.ok_list.map((d) => { notList.push(d.insta_user_id); });
    this.props.ng_list.map((d) => { notList.push(d.insta_user_id); });
    
    return (
      <div className={'progress-space '+ data.id}>
        <h2><i className="material-icons">{data.icon}</i>{data.name} ({list.length}<span>人</span>)</h2>
        
        <div className="progress-base">
          
          { statusArray.map((d, key) => {
            
            // キャプション
            let caption = null;
            try { if( d.recommend_text != undefined && d.recommend_text != null ) caption = Sanitize.nl2br(d.recommend_text); } catch(e) {}
            
            return (
              <div key={key} className="progress-base-item">
                { (d.recommend_date != null ) && <h5>{Utils.setDate(d.recommend_date, 'YYYY年M月D日 HH:mm')}</h5> }
                { (d.recommend_date != null ) ? <h4 dangerouslySetInnerHTML={{ __html: caption }} /> : <h6 /> }
                <Sortable options={{ group: 'shared', animation: 150 }} tag="ul" className="progress-base-scroll" onChange={this.props.change_ev.bind(this)}>
                  { d.ary.map((p, pkey) => {
                    if( notList.indexOf(p.insta_user_id) >= 0 ) return null;
                    return <ProgressCard key={pkey} data={p} base={base} />;
                  })}
                </Sortable>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressBase;